import Phaser from "phaser";
import { SeasonSelection, SeasonType } from "../data/enums";
import { GameplayLaunchData, lakeData, selectableSeasons } from "../data/lakeData";
import { REFERENCE_HEIGHT, REFERENCE_WIDTH } from "../game/constants";
import { ProgressionService } from "../systems/ProgressionService";

export class LakeSelectScene extends Phaser.Scene {
    private seasonSelection: SeasonSelection = SeasonSelection.Random;

    constructor() {
        super("LakeSelectScene");
    }

    create(): void {
        this.add.rectangle(REFERENCE_WIDTH / 2, REFERENCE_HEIGHT / 2, REFERENCE_WIDTH, REFERENCE_HEIGHT, 0x123f60);

        this.add
            .text(REFERENCE_WIDTH / 2, 150, "Select Lake", {
                fontSize: "72px",
                color: "#ffffff",
            })
            .setOrigin(0.5);

        const lifetimeScore = ProgressionService.getLifetimeScore();
        this.add
            .text(REFERENCE_WIDTH / 2, 225, `Lifetime Score: ${lifetimeScore}`, {
                fontSize: "34px",
                color: "#d4ecff",
            })
            .setOrigin(0.5);

        const seasonButton = this.add
            .rectangle(REFERENCE_WIDTH / 2, 310, 520, 82, 0x1d557d)
            .setStrokeStyle(3, 0xffffff)
            .setInteractive({ useHandCursor: true });

        const seasonLabel = this.add
            .text(REFERENCE_WIDTH / 2, 310, this.getSeasonLabel(), {
                fontSize: "34px",
                color: "#ffffff",
            })
            .setOrigin(0.5);

        seasonButton.on("pointerdown", () => {
            this.seasonSelection = this.getNextSeasonSelection(this.seasonSelection);
            seasonLabel.setText(this.getSeasonLabel());
        });

        const startX = 450;
        const gap = 510;
        lakeData.forEach((lake, index) => {
            const unlocked = ProgressionService.isLakeUnlocked(lake);
            const x = startX + index * gap;
            const y = 610;

            const card = this.add.rectangle(x, y, 440, 290, unlocked ? 0x1e5a84 : 0x3a4860).setStrokeStyle(4, unlocked ? 0xffffff : 0x8892a6);
            const textWidth = 380;

            this.add
                .text(x, y - 72, lake.name, {
                    fontSize: "40px",
                    color: unlocked ? "#ffffff" : "#c7cedd",
                    align: "center",
                    fixedWidth: textWidth,
                    wordWrap: {
                        width: textWidth,
                        useAdvancedWrap: true,
                    },
                })
                .setOrigin(0.5);

            const subtitle = unlocked ? `Gas x${lake.gasDrainMultiplier.toFixed(2)}` : `Unlock at ${lake.unlockLifetimeScore} lifetime score`;
            this.add
                .text(x, y + 12, subtitle, {
                    fontSize: "28px",
                    color: unlocked ? "#d4ecff" : "#d0c8cf",
                    align: "center",
                    fixedWidth: textWidth,
                    wordWrap: {
                        width: textWidth,
                        useAdvancedWrap: true,
                    },
                })
                .setOrigin(0.5);

            if (!unlocked) {
                this.add
                    .text(x, y + 72, "LOCKED", {
                        fontSize: "32px",
                        color: "#ff9aa2",
                        fontStyle: "bold",
                    })
                    .setOrigin(0.5);
                return;
            }

            card.setInteractive({ useHandCursor: true });
            card.on("pointerdown", () => {
                const launchData: GameplayLaunchData = {
                    lakeKey: lake.key,
                    season: this.resolveSelectedSeason(),
                };
                this.scene.start("GameplayScene", launchData);
            });
        });

        this.input.keyboard?.on("keydown-ESC", () => this.scene.start("MainMenuScene"));
    }

    private getNextSeasonSelection(current: SeasonSelection): SeasonSelection {
        const order = [SeasonSelection.Random, SeasonSelection.Spring, SeasonSelection.Summer, SeasonSelection.Fall, SeasonSelection.Winter];
        const index = order.indexOf(current);
        return order[(index + 1) % order.length];
    }

    private getSeasonLabel(): string {
        return `Season: ${this.seasonSelection}`;
    }

    private resolveSelectedSeason(): SeasonType {
        if (this.seasonSelection === SeasonSelection.Random) {
            return Phaser.Utils.Array.GetRandom(selectableSeasons);
        }
        switch (this.seasonSelection) {
            case SeasonSelection.Spring:
                return SeasonType.Spring;
            case SeasonSelection.Summer:
                return SeasonType.Summer;
            case SeasonSelection.Fall:
                return SeasonType.Fall;
            case SeasonSelection.Winter:
                return SeasonType.Winter;
            default:
                return SeasonType.Summer;
        }
    }
}
